import {List} from "immutable";
import * as React from 'react';
import {useState} from "react";
import {Button, Header, Table} from "semantic-ui-react";
import {printIsoDateString} from "../../../core/dateTime";
import UserAvatar from "../../../User/components/UserAvatar";
import {IioUserInfo} from "../../../User/model/IioUserInfo";
import {Playshot} from "../../model/Playshot";
import {PlayshotId, PlayshotSummary} from "../../model/PlayshotSummary";
import {stringify} from "../../service/json/json-comment-wrapper";
import {loadPlayshot} from "../../service/playshot-storage";
import {PlayshotComparison} from "./PlayshotModal";

interface OwnProps {
  playshot: PlayshotSummary,
  previous: PlayshotSummary | null,
  users: List<IioUserInfo>,
  onInitPlayshot: (playshotId: PlayshotId) => void,
  onComparePlayshots: (comparision: PlayshotComparison) => void,
  onDeletePlayshot: (playshotId: PlayshotId) => void,
  loading: boolean,
}

type PlayshotTableRowProps = OwnProps;

const PlayshotTableRow = (props: PlayshotTableRowProps) => {
  const user = props.users.find(u => u.userId === props.playshot.savedBy);
  const [exporting, setExporting] = useState(false);
  const [loadingPlayshots, setLoadingPlayshots] = useState(false);
  const [deletingPlayshot, setDeletingPlayshot] = useState(false);

  const handleExport = () => {
    setExporting(true);
    loadPlayshot(props.playshot.boardId, props.playshot.uid).then(playshot => {
      setExporting(false);

      const playshotData = playshot.toJS();

      delete playshotData.uid;
      delete playshotData.aggregateType;

      const json = stringify(playshotData, null, 2);


      const blob = new Blob([json], {type: 'application/json'});
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');

      a.download = props.playshot.name + '.json';
      a.href = url;
      a.click();
    })
  }

  const handleDelete = () => {
    setDeletingPlayshot(true);
    props.onDeletePlayshot(props.playshot.uid);
  }

  const handleShowChanges = () => {
    setLoadingPlayshots(true);

    const prevPlayshotPromise: Promise<Playshot> = new Promise(resolve => {
      if (props.previous === null) {
        resolve(new Playshot({}));
      } else {
        loadPlayshot(props.playshot.boardId, props.previous.uid).then(prev => resolve(prev));
      }
    });

    const playshotPromise = loadPlayshot(props.playshot.boardId, props.playshot.uid);

    Promise.all([prevPlayshotPromise, playshotPromise]).then((playshots) => {
      props.onComparePlayshots({left: playshots[0], right: playshots[1]});
    }).catch(e => {
      throw e;
    }).finally(() => setLoadingPlayshots(false))
  }

  return <Table.Row>
    <Table.Cell>
      <Header as="h4" image={true}>
        {user && <UserAvatar user={user} namePopup={true}/>}
        <Header.Content>
          {props.playshot.name}
          <Header.Subheader>{printIsoDateString(props.playshot.savedAt)}</Header.Subheader>
        </Header.Content>
      </Header>
    </Table.Cell>
    <Table.Cell textAlign="right">
      <Button icon="play" loading={props.loading} primary={true} circular={true} onClick={() => props.onInitPlayshot(props.playshot.uid)} title="Start Playshot" />
    </Table.Cell>
    <Table.Cell textAlign="right" width={"1"}>
      <Button icon="sync" loading={loadingPlayshots} basic={true} circular={true} className="noborder" onClick={handleShowChanges} title="Sync Changes" />
    </Table.Cell>
    <Table.Cell textAlign="right" width={"1"}>
      <Button icon="download" loading={exporting} basic={true} circular={true} className="noborder" onClick={handleExport} title="Download Playshot" />
    </Table.Cell>
    <Table.Cell textAlign="right" width={"1"}>
      <Button icon="trash" loading={deletingPlayshot} basic={true} circular={true} className="noborder" onClick={handleDelete} title="Delete Playshot" />
    </Table.Cell>
  </Table.Row>
};

export default PlayshotTableRow;
